import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TEInterceptor implements HttpInterceptor {
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let clone = req.clone({
			withCredentials: true,
		});


		// if (clone.method === 'POST') {
		// 	const arrUrl = clone.url.split('/');

		// 	if (arrUrl[arrUrl.length - 1] === 'upload' && arrUrl[arrUrl.length - 2] === 'files') {
		// 		clone = req.clone({
		// 			setHeaders: { connection: 'keep-alive' },
		// 			withCredentials: true
		// 		});

		// 		console.log(clone.headers)
		// 	}
		// }

		return next.handle(clone);
	}
}